import './styles.scss';

import React, {PropsWithChildren} from 'react';

export const AppSeparator = ({children}: PropsWithChildren) => {
    const hasChildren = children && React.Children.count(children) > 0;
    
    return (
        <div className={`app-separator ${!hasChildren ? 'app-separator--no-children' : ''}`}>
            {hasChildren && <span>{children}</span>}
        </div>
    );
};
